<h1 class="page-title">Update Course</h1>
<app-course-editor [course$]="course$" ></app-course-editor>